// extracted by mini-css-extract-plugin
export default {"Delta":"Delta20qbmuvkJ3dg","Delta-number":"Delta-number3AMkTkXjrE8h","Delta_positive":"Delta_positive4bnhIvsI63EV","Delta_negative":"Delta_negative1SxQ8Wkx67ia"};